import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Tab2 from './Tab2';
const Tab1 = ({ alldata ,isLoading}) => {

  console.log(isLoading,"isLoading",alldata);
  
  if (isLoading) {
    return <p>Loading...</p>; // or show a skeleton loader
  }
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
            id="SerialNo"
            readOnly
            label="Serial No"
            style={{
              height: "30px",
             
            }}
               value={alldata?.name || ""}
            
          />
        </div>
      </div>

      <div className="col-6">
        <div className={ `mb-3`}>
          <Input
            id="ItemCode"
            readOnly
            label="Item Code"
            style={{
              height: "30px",
              
            }}
 value={alldata?.item_code || ""}          />
         
         
        </div>
      </div>
      
    </div>
   
  );
};

export default Tab1;